import { Col, Row } from 'antd';
import { useSelector } from 'react-redux';
import UserMenu from '@copilot/common/components/menus/user';
import { OrganizationMemberSelectors } from '@copilot/common/store/selectors/organizationMember';
import { EnvironmentType } from './constant';
import { Config } from '@copilot/common/config';
import SupportDropdown from '@copilot/cs/src/components/menus/header/support';
import { isSystemAdmin } from '@copilot/common/utils/organizationMember';
import { useAppcues, addAppcuesLaunchpad } from '@copilot/common/components/snippets/appcues';
import { Notifications } from '../../../../../common/pages/layouts/headerSider/header/notificationDropdown';

type CsHeaderProps = {
    environmentType: EnvironmentType;
    showNotifications?: boolean;
    showSaved?: boolean;
    showProfile: boolean;
    showSettings: boolean;
    isCalendly: boolean;
};

export function CsHeader({
    showProfile,
    showSettings,
    showNotifications = true,
    showSaved = false,
    isCalendly,
}: CsHeaderProps) {
    const activeMember = useSelector(OrganizationMemberSelectors.getActiveMember);
    const showCalendly =
        isCalendly && !Config.isAgency && !!activeMember && isSystemAdmin(activeMember);
    const activeAdmin = useSelector(OrganizationMemberSelectors.getAdminMember);
    const appcuesContext = useAppcues();
    return (
        <Row gutter={16} justify="space-between">
            <Col style={{ flexGrow: 1 }} />
            {!Config.isAgency && (
                <Col
                    style={{
                        color: 'white',
                        cursor: 'pointer',
                    }}
                >
                    <SupportDropdown
                        isHelpPortalDisabled={!Config.helpPortalURL}
                        isReportBugDisabled={!Config.intercomAppId}
                        onOpenSiteStatus={
                            Config.siteStatusURL
                                ? () => window.open(Config.siteStatusURL)
                                : undefined
                        }
                        onOpenHelpPortal={() => window.open(Config.helpPortalURL)}
                        onLoad={() =>
                            Config.isAppcuesEnabled && addAppcuesLaunchpad(appcuesContext)
                        }
                    />
                </Col>
            )}
            <Col style={{ marginTop: '5px' }}>
                {showSaved}
                {showNotifications && <Notifications />}
            </Col>
            <Col>
                {activeMember && (
                    <UserMenu
                        user={activeMember}
                        admin={activeAdmin}
                        fontColor="white"
                        showProfile={showProfile}
                        showCalendly={showCalendly}
                        showSettings={showSettings}
                    />
                )}
            </Col>
        </Row>
    );
}
